// Resumen legible de lo que hizo el backend al reagendar una demo (respuesta de
// PUT /ventas/demos → { sync }). Lo enseñan los tres caminos de reagenda (arrastrar
// en el calendario, modal del calendario y ficha del lead) para que el usuario sepa
// todo lo que el sistema ha movido por detrás sin tener que preguntarlo.
export function buildRescheduleSummary(resp, t) {
  const sync = resp?.sync || {};
  const lines = [t("translation:demos.summary.title")];

  lines.push(
    sync.lead_notified
      ? t("translation:demos.summary.leadNotified")
      : t("translation:demos.summary.leadNotNotified")
  );
  lines.push(
    sync.closer_notified
      ? t("translation:demos.summary.closerNotified")
      : t("translation:demos.summary.closerNotNotified")
  );

  const reminders = Array.isArray(sync.reminders) ? sync.reminders : [];
  if (reminders.length === 0) {
    lines.push(t("translation:demos.summary.noReminders"));
  } else {
    for (const r of reminders) {
      lines.push(
        r.action === "moved"
          ? t("translation:demos.summary.reminderMoved", { kind: r.kind })
          : t("translation:demos.summary.reminderDeleted", { kind: r.kind })
      );
    }
  }

  if (sync.calendar_rows > 0) {
    lines.push(t("translation:demos.summary.calendarMoved"));
  }

  return lines.join("\n");
}
